import React from 'react';
import { Space } from 'antd';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { Option, Select } from '@app/components/common/selects/Select/Select';
import { completionModel } from '@app/constants/completionModel';

const completionModelOptions = completionModel.map((model) => (
  <Option key={model.id} value={model.value}>
    <Space align="center">{model.name}</Space>
  </Option>
));

export const CompletionModelItem: React.FC = () => {
  return (
    <BaseButtonsForm.Item name="completionModel" label="Completion model">
      <Select>{completionModelOptions}</Select>
    </BaseButtonsForm.Item>
  );
};
